import { render, staticRenderFns } from "./TepTarifaInterno.vue?vue&type=template&id=dcc85b5c"
import script from "./TepTarifaInterno.vue?vue&type=script&lang=js"
export * from "./TepTarifaInterno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports